<template>
  <v-layout justify-end class="wrapper">
    <v-flex shrink class="flex_row_number">
      <v-select
        v-model="perPage"
        class="row_number"
        :items="perPageOpts"
        solo
        flat
        dense
        single-lines
        @change="$emit('changePerPage', { page: pagination.page, per_page: $event })"
      />
    </v-flex>
    <v-flex shrink class="items_on_the_right">
      <v-layout>
        <div v-if="isDesktop" class="item_number_container">rows per page</div>
        <div class="item_number_container">{{ currentAttendeeNumber }}</div>
        <v-btn
          icon
          flat
          class="arrow"
          :disabled="pagination.page === 1"
          @click="$emit('change', { page: pagination.page - 1, per_page: perPage })"
        >
          <v-icon>chevron_left</v-icon>
        </v-btn>
        <v-btn
          icon
          flat
          class="arrow"
          :disabled="!canIncrement"
          @click="$emit('change', { page: pagination.page + 1, per_page: perPage })"
        >
          <v-icon>chevron_right</v-icon>
        </v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'table-pagination',
  props: {
    pagination: {
      type: Object,
      default: () => ({
        per_page: 10,
        page: 1,
      }),
    },
    totalAttendees: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      perPage: this.pagination.per_page,
      perPageOpts: [5, 10, 25, 100, 'All'],
      isDesktop: false,
    }
  },
  computed: {
    currentAttendeeNumber() {
      const { per_page, page } = this.pagination

      if (per_page === 'All') return `1 - ${this.totalAttendees} of ${this.totalAttendees}`

      const total = per_page * page
      const rangeEnd = total < this.totalAttendees ? total : this.totalAttendees

      return `${per_page * (page - 1) + 1} - ${rangeEnd} of ${this.totalAttendees}`
    },
    canIncrement() {
      const { per_page, page } = this.pagination

      return this.totalAttendees - per_page * page > 0
    },
  },
  watch: {
    pagination: {
      handler(val) {
        this.per_page = val.per_page
      },
      deep: true,
    },
  },
  created() {
    //Initially if we have query param on route per_page set to -1 the all option is not selected
    this.perPage = this.perPage === -1 ? 'All' : this.perPage
    window.addEventListener('resize', this.resizeHandler)
    if (window.innerWidth > 800) {
      this.isDesktop = true
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeHandler)
  },
  methods: {
    resizeHandler() {
      if (window.innerWidth > 800) {
        this.isDesktop = true
      } else {
        this.isDesktop = false
      }
    },
  },
}
</script>

<style scoped>
.wrapper {
  background-color: white;
  height: 40px;
  border-radius: 0px 0px 8px 8px;
  border: solid 2px #f5f5f5;
  border-top: none;
  text-align: left;
}
.arrow {
  margin: 0px;
  margin-right: 24px;
  padding: 0;
  text-align: right;
}
.item_number_container {
  margin-right: 48px;
  text-align: right;
  align-self: center;
  color: #979797;
}
@media screen and (max-width: 337px) {
  .item_number_container {
    margin-right: 0.625rem !important;
  }
}
.items_on_the_right {
  text-align: right;
  align-self: center;
  padding-top: 0px;
}
.drop_down_arrow {
  text-align: right;
  margin-right: 8px;
}
.flex_row_number {
  display: flex;
  justify-content: end;
  margin-right: 14px;
}
.row_number {
  padding: 0px;
  margin: 20px 30px 0px 0px !important;
  align-items: center;
  font-size: 14px;
  max-width: 30px;
}
>>> .v-input__control {
  min-height: 0px !important;
}
</style>
